import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class SpeechTherapy extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Speech Therapy</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Speech Therapy</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Speech Therapy</h2>

                      <p>
                        Speech Therapy is a specialized service that helps children develop the
                        communication skills they need to participate confidently in everyday life.
                        Effective communication is essential for learning, building relationships,
                        expressing thoughts and emotions, and interacting with the world. Some
                        children may experience challenges with speech production, language
                        development, fluency, voice quality, or social communication, which can
                        affect their ability to communicate at home, in school, and within the
                        community.
                      </p>

                      <p>
                        Our Speech Therapy program focuses on identifying and addressing communication
                        difficulties through individualized assessment and evidence-based
                        intervention. Each therapy plan is designed to help children improve their
                        understanding of language, express their thoughts and needs effectively,
                        pronounce speech sounds clearly, expand their vocabulary, and communicate
                        with greater confidence.
                      </p>
                      <p>Therapy sessions are tailored to each child's unique strengths,
                        developmental stage, and specific goals. Our therapists use a variety
                        of engaging techniques, including play-based learning, language
                        stimulation, storytelling, conversation practice, articulation exercises,
                        and structured communication activities to create meaningful learning
                        experiences. Parents and caregivers are actively involved throughout
                        the therapy process, helping reinforce newly acquired skills in
                        daily life.</p>

                      <div className="row">

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Who Can Benefit?</h3>

                          <ul>
                            <li>Children with developmental delays</li>
                            <li>Autism Spectrum Disorder (ASD)</li>
                            <li>Cerebral Palsy</li>
                            <li>ADHD</li>
                            <li>Speech and language delays</li>
                            <li>Learning disabilities</li>
                          </ul>
                        </div>

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Our Goals</h3>

                          <ul>
                            <li>Promote physical and cognitive development</li>
                            <li>Improve communication skills</li>
                            <li>Develop social and emotional abilities</li>
                            <li>Encourage independence</li>
                            <li>Prepare children for school and daily life</li>
                            <li>Support families through early guidance</li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default SpeechTherapy;
